import { SchemableFormNavigationContextProvider } from 'contexts/SchemableFormNavigationContext/SchemableFormNavigationContextProvider';
import { DisplayModes } from 'services/webedi/types';
import { WebEDIErrorsServiceSingleton } from 'services/webediErrors';
import { WebEDIAnnotation } from 'services/webediErrors/types';
import { MessageV2DTO } from 'support/types';
import { FieldAnnotationPopover } from 'components/WebEDI/FieldAnnotationPopover/FieldAnnotationPopover';
import { WebEDIMessageErrorBanner } from 'components/WebEDI/WebEDIMessageErrorBanner/WebEDIMessageErrorBanner';

import { PaymentReconciliationBanner } from '../PaymentReconciliationBanner/PaymentReconciliationBanner';

type PaymentReconciliationTopBannerProps = {
  blockingError: MessageV2DTO['blocking_error'];
  hasPendingItems: boolean;
  isFilteringPendingOnly: boolean;
  onTogglePendingFilter: () => void;
};

export const PaymentReconciliationTopBanner = ({
  blockingError,
  hasPendingItems,
  isFilteringPendingOnly,
  onTogglePendingFilter,
}: PaymentReconciliationTopBannerProps) => {
  if (blockingError) {
    return (
      <SchemableFormNavigationContextProvider<WebEDIAnnotation>
        service={WebEDIErrorsServiceSingleton}
        NavigableItemPopoverComponent={FieldAnnotationPopover}
      >
        <WebEDIMessageErrorBanner mode={DisplayModes.view} blockingError={blockingError} />
      </SchemableFormNavigationContextProvider>
    );
  }

  if (hasPendingItems) {
    return <PaymentReconciliationBanner onCheckboxClick={onTogglePendingFilter} checked={isFilteringPendingOnly} />;
  }

  return null;
};
